var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.807 6.57h4.386v2.892c0 1.924 1.804 2.049 2.928 2.091L10 17.542l-4.948-5.989c1.124-.042 2.755.094 2.755-2.09V6.57zm.963 12.857c.3.364.749.573 1.23.573s.93-.209 1.23-.573l6.428-7.798c.375-.455.448-1.09.189-1.616a1.591 1.591 0 0 0-1.42-.867h-1.64V5.528c0-.842-.705-1.528-1.573-1.528H6.786c-.868 0-1.575.686-1.575 1.528v3.618H3.573a1.59 1.59 0 0 0-1.42.868 1.5 1.5 0 0 0 .191 1.616l6.426 7.797zM13.774 2c.483 0 .877-.449.877-1 0-.551-.394-1-.877-1H5.877C5.394 0 5 .449 5 1c0 .551.394 1 .877 1h7.897z",
    fill: "#93C5C5",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropOff);
export default __webpack_public_path__ + "static/media/drop_off.4a39a806c8268132d4ad1f7863bd61b3.svg";
export { ForwardRef as ReactComponent };